export const styles = {
  imgFacebook: {
    width: "100%",
    height: "auto",
  },
  separator: { paddingLeft: "5%", paddingRight: "5%" },
  inputStyle: {
    backgroundColor: "#f0f0f0",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    textDecoration: "none",
  },
  buttonSubmitContainer: {
    width: "100%",
    textAlign: "center",
  },
  rounded: {
    borderTopLeftRadius: "2%",
    borderTopRightRadius: "2%",
  },
};
